import React from 'react';
import PropTypes from 'prop-types';
import { Banner } from '@els/els-react--banner';
import InnerHTML from '@Components/InnerHTML';
import { allowedTagsDefault } from '@Services/HtmlSanitizeService';
import useParseMaintainMessage from '@Containers/InProductMessages/MaintainMessage/useParseMaintainMessage';

import './MaintainMessage.scss';

function MaintainMessage({ message }) {
  const parsedMessage = useParseMaintainMessage({ message });

  return (
    <Banner type="alert" isVisible className="maintenance-banner">
      <InnerHTML
        tag="span"
        className="maintenance-banner__text"
        html={parsedMessage}
        mode="escape"
        allowedTags={allowedTagsDefault.concat('a')}
        allowedAttributes={['href', 'target']}
      />
    </Banner>
  );
}

MaintainMessage.propTypes = {
  message: PropTypes.string,
};

export default MaintainMessage;
